/** 门店物资管理API */
import type { Api } from '@/typings/api';
import { post } from '../../request';
const prefix = '/store/materialItem';
/**
 * 分页查询门店物资管理
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Store.MaterialItem> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询门店物资管理列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Store.MaterialItem> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个门店物资管理
 *
 * @param id 门店物资管理ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Store.MaterialItem> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存门店物资管理
 *
 * @param params 门店物资管理信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新门店物资管理信息
 *
 * @param params 门店物资管理信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除门店物资管理
 *
 * @param id 门店物资管理ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除门店物资管理
 *
 * @param ids 门店物资管理ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete
};
